import "./styles.css";
import translations from "@/config/translations";
import useLangStore from "@/hooks/useLangStore";

export interface ConfirmPopupDetails {
    message: string;
    icon?: string;
    variant?: "danger" | "primary";
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onDecline?: () => void;
}

interface Props {
    onClose: () => void;
    details?: ConfirmPopupDetails;
}

export default function ConfirmPopup({ onClose, details }: Props) {
    const { lang } = useLangStore();
    const t = translations[lang ?? "ar"];

    const variant = details?.variant ?? "danger";
    const confirmLabel = details?.confirmLabel ?? t.confirmPopup.confirm;
    const cancelLabel = details?.cancelLabel ?? t.confirmPopup.cancel;

    const handleConfirm = () => {
        details?.onConfirm();
        onClose();
    };

    const handleDecline = () => {
        details?.onDecline?.();
        onClose();
    };

    return (
        <div className="confirm-popup">
            {details?.icon && (
                <div className={`confirm-popup-icon-wrap confirm-popup-icon-wrap--${variant}`}>
                    <img src={details.icon} alt="" width={24} height={24} className={`confirm-popup-icon confirm-popup-icon--${variant}`} />
                </div>
            )}

            <p className="confirm-popup-message">{details?.message}</p>

            <div className="confirm-popup-actions">
                <button type="button" className="confirm-popup-btn confirm-popup-btn--cancel" onClick={handleDecline}>
                    {cancelLabel}
                </button>
                <button
                    type="button"
                    className={`confirm-popup-btn confirm-popup-btn--confirm confirm-popup-btn--${variant}`}
                    onClick={handleConfirm}
                >
                    {confirmLabel}
                </button>
            </div>
        </div>
    );
}
